var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaidinvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_38844",
    x: 19.469,
    y: 23.135,
    width: 21.784,
    height: 18.584,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Paid_invoice",
    "data-name": "Paid invoice",
    transform: "translate(-1043.518 -1059.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38828",
    "data-name": "Path 38828",
    d: "M26,0A26,26,0,1,1,0,26,26,26,0,0,1,26,0",
    transform: "translate(1043.518 1059.674)",
    fill: "#56aa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38829",
    "data-name": "Path 38829",
    d: "M11.814,37.939l3.7,3.516,3.807-3.62,3.873,3.683,3.782-3.595L30.74,41.5l4.016-3.82,3.37,3.384V6.561H7.988v34.79Z",
    transform: "translate(1046.461 1062.091)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38830",
    "data-name": "Path 38830",
    d: "M26.5,11.088H10.72a1.094,1.094,0,1,1,0-2.188H26.5a1.094,1.094,0,0,1,0,2.188",
    transform: "translate(1049.237 1065.356)",
    fill: "#e0e1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38831",
    "data-name": "Path 38831",
    d: "M21.782,15.277H10.72a1.094,1.094,0,1,1,0-2.188H21.782a1.094,1.094,0,0,1,0,2.188",
    transform: "translate(1049.236 1068.031)",
    fill: "#e0e1e3"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1043.52, 1059.67)",
    filter: "url(#Path_38844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38844-2",
    "data-name": "Path 38844",
    d: "M16.262,0,5.695,10.568l-3.2-3.135L0,9.98l5.721,5.6L18.783,2.521Z",
    transform: "translate(20.97 23.63)",
    fill: "#56aa1c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidinvoice);
export default __webpack_public_path__ + "static/media/Paid invoice.69ceed1f098ebac83daa98d0275e9a5f.svg";
export { ForwardRef as ReactComponent };